export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Splash de mostarda atrás do conteúdo */}
      <div
        aria-hidden
        className="absolute -top-32 -right-32 h-[28rem] w-[28rem] rounded-full bg-brand-500/30 blur-3xl"
      />
      <div
        aria-hidden
        className="absolute -bottom-40 -left-40 h-[24rem] w-[24rem] rounded-full bg-brand-300/30 blur-3xl"
      />

      <div className="relative max-w-6xl mx-auto px-6 py-24 md:py-32">
        <div className="max-w-3xl">
          <span className="chip mb-6">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-500" />
            Pagamentos sem mistério
          </span>

          <h1 className="font-display font-extrabold text-ink leading-[0.95] tracking-tightest text-5xl md:text-7xl">
            Receba.
            <br />
            Repasse.
            <br />
            <span className="inline-block relative">
              <span className="relative z-10">OK!pag.</span>
              <span
                aria-hidden
                className="absolute inset-x-0 bottom-1 md:bottom-2 h-3 md:h-5 bg-brand-500 -z-0"
              />
            </span>
          </h1>

          <p className="mt-8 text-lg md:text-xl text-ink-muted max-w-2xl leading-relaxed">
            A plataforma de pagamentos que <span className="font-semibold text-ink">não te faz pensar</span>.
            Liquidação rápida, integração sem dor de cabeça e suporte que responde.
          </p>

          <div id="cta" className="mt-10 flex flex-wrap items-center gap-4">
            <a href="#contato" className="btn-primary">
              Fale com a gente
              <span className="font-display text-xl leading-none">!</span>
            </a>
            <a href="#features" className="btn-ghost">
              Ver recursos
            </a>
          </div>

          {/* Selos de confiança */}
          <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-xl">
            {[
              { kpi: "99.99%", label: "uptime" },
              { kpi: "<1s", label: "liquidação" },
              { kpi: "256-bit", label: "criptografia" },
              { kpi: "24/7", label: "suporte" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="font-display font-bold text-2xl text-ink">{stat.kpi}</div>
                <div className="text-xs uppercase tracking-wider text-ink-muted mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
